// import { userGuard } from '~/router/middleware/guards';
import Calculator from '~/components/pages/otm/Calculator.vue';
import SavedMarginReportsList from '~/components/pages/otm/SavedMarginReportsList.vue';
import SavedMarginReportEdit from '~/components/pages/otm/SavedMarginReportEdit.vue';

const prefix = 'otm';

export default [
  {
    path: `/${prefix}/calculator`,
    name: 'otm.calculator',
    component: Calculator,
    // middleware: {
    //   permissions: ['statiz.transcribe-search.report']
    // },
    // beforeEnter: userGuard
  },
  {
    path: `/${prefix}/saved-margin-reports`,
    name: 'otm.saved-margin-reports.list',
    component: SavedMarginReportsList,
  },
  {
    path: `/${prefix}/saved-margin-reports/:id`,
    name: 'otm.saved-margin-reports.edit',
    component: SavedMarginReportEdit,
  },
]
